import { PaginatedTable, PaginatedTableProps } from "./PaginatedTable";
import { useColumnSelection } from "./ViewColumnSelection";

/**
 * Notes about using this component:
 * - Column selection is persisted in URL search params and _ separated, so column ids cannot contain _.
 * - This also means that you likely can't have more than 1 of this table on the same page (case not tested as of this writing).
 * - If resourceName is provided, it is used to persist column selection in local storage.
 */

type CustomColumnsTableProps<T> = PaginatedTableProps<T> & {
  requiredColumnIds?: string[];
  showAdvancedViewSettingsOnly?: boolean;
  advancedViewSettings?: React.ReactNode;
  resourceName?: string;
  columnVisibilityPrefixesToExpand?: string[];
};

export function CustomColumnsTable<T>({
  requiredColumnIds,
  showAdvancedViewSettingsOnly,
  advancedViewSettings,
  resourceName,
  columnVisibilityPrefixesToExpand,
  ...table
}: CustomColumnsTableProps<T>) {
  const { columnVisibility, ViewColumnSelector } = useColumnSelection({
    allColumns: table.columns.map((column) => ({
      id: column.id ?? "",
      header:
        column.headerText ??
        (typeof column.header === "string" ? column.header : column.id ?? ""),
    })),
    requiredColumnIds,
    resourceName,
    showAdvancedSettingsOnly: showAdvancedViewSettingsOnly,
    advancedSettings: advancedViewSettings,
    columnVisibilityPrefixesToExpand,
  });

  return (
    <PaginatedTable
      columnVisibility={columnVisibility}
      viewColumnSelector={ViewColumnSelector}
      {...table}
    />
  );
}
